module.exports = __webpack_public_path__ + "img/tiff.d74d2e10.svg";